import { Home, Users, DollarSign, Server, FileMinus, Shield, UserCheck, Inbox, HelpCircle, Package, Bookmark, Trello, AlertCircle, Settings, Archive, TrendingUp } from 'react-feather';
import { CiSquareAlert } from "react-icons/ci";
import { IoDocuments } from "react-icons/io5";


import { useSelector } from 'react-redux';

export const generateMenuItems = () => {
    const authState = useSelector((state) => state.auth);
    const modules = authState?.modules;

    const openStatsus2 = localStorage.getItem('newOpen2') || true;
    return [
        {
            menutitle: 'General',
            Items: [
                {
                    title: 'Dashboard', path: `${process.env.PUBLIC_URL}/dashboard/default`, icon: Home, type: 'link', active: false,
                },
                //lead manage

                //  (authState.userRole === 1 ||
                //     authState.permissions.includes('show-user')) &&

                (authState.userRole === 1 ||
                    authState.permissions.includes('show-lead-manager')) && {
                    title: 'Lead Manager', icon: Inbox, type: 'sub', active: false, children: [
                        { path: `${process.env.PUBLIC_URL}/lead-manage/enquiry`, title: 'Enquiries', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/lead-manage/leads`, title: 'Leads', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/lead-manage/follow-ups`, title: 'Follow-ups', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/lead-manage/overdue-follow-ups`, title: 'Overdues', type: 'link' },
                    ]
                },
                {
                    title: 'Quotation', icon: Trello, type: 'sub', active: false, children: [
                        { path: `${process.env.PUBLIC_URL}/quotation/quotation-list`, title: 'Quotation', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/quotation/quotation-layout`, title: 'Quotation Layout', type: 'link' },
                    ]
                },
                (authState.userRole === 1 ||
                    authState.permissions?.includes('show-customer') ||
                    authState.permissions?.includes('show-stb') ||
                    authState.permissions?.includes('show-wallet')) &&
                ({

                    title: 'Customers', icon: Users, type: 'sub', active: false, children: [
                        (authState.userRole === 1 || authState.permissions.includes('show-customer')) && (
                            { path: `${process.env.PUBLIC_URL}/customers/customer`, title: 'Customer', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('show-stb')) && (
                            { path: `${process.env.PUBLIC_URL}/customers/service-accounts`, title: 'Service Accounts', type: 'link' }
                        ),

                        (authState.userRole === 1 || authState.permissions.includes('show-customer')) && (
                            { path: `${process.env.PUBLIC_URL}/customers/customer-archive`, title: 'Customer Archive', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('show-customer')) && (
                            { path: `${process.env.PUBLIC_URL}/customers/customer-documents`, title: 'Customer Documents', type: 'link' }
                        ),
                        // (authState.userRole === 1 || authState.permissions.includes('show-stb')) && (
                        //     { path: `${process.env.PUBLIC_URL}/customers/stb-modem`, title: 'STB/Modem', type: 'link' }
                        // ),
                        (authState.userRole === 1 || authState.permissions.includes('show-wallet')) && (
                            { path: `${process.env.PUBLIC_URL}/customers/wallet`, title: 'Wallet', type: 'link' }
                        ),
                    ]

                }),
                (Array.isArray(modules) && modules.some((item) => item?.module_name === 'stamping')) &&
                //  (authState.userRole === 1 ||
                //     authState.permissions.includes('show-stamping') ) &&
                ({
                    title: 'Stamping', icon: Shield, type: 'sub', active: false, children: [

                        // (authState.userRole === 1 || authState.permissions.includes('show-customer')) &&
                        (
                            { path: `${process.env.PUBLIC_URL}/stamping/stamping-customer`, title: 'Stamping Account', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('show-transaction')) &&
                        (
                            { path: `${process.env.PUBLIC_URL}/stamping/stamping-due`, title: 'Stamping Due', type: 'link' }
                        )
                    ]
                }),
                (authState.userRole === 1 || authState.permissions.includes('show-complaint')) && (
                    {
                        title: 'Service Requests', icon: AlertCircle, type: 'sub', active: false, children: [
                            { path: `${process.env.PUBLIC_URL}/service-request`, title: 'Service Requests', type: 'link' },
                            { path: `${process.env.PUBLIC_URL}/service-request/service-request-dues`, title: 'Service Account dues', type: 'link' },
                        ]
                    }
                ),
                (authState.userRole === 1 ||
                    authState.permissions.includes('show-subscription') ||
                    authState.permissions.includes('activate-subscription') ||
                    authState.permissions.includes('show-invoice')) &&
                ({
                    title: 'Billing', icon: DollarSign, type: 'sub', active: false, children: [
                        // (authState.userRole === 1 || authState.permissions.includes('show-subscription')) && (
                        //     { path: `${process.env.PUBLIC_URL}/billing/subscription`, title: 'Subscription', type: 'link' }
                        // ),
                        // (authState.userRole === 1 || authState.permissions.includes('activate-subscription')) && (
                        //     { path: `${process.env.PUBLIC_URL}/billing/activate-subscription`, title: 'Activate Subscription', type: 'link' }
                        // ),
                        (authState.userRole === 1 || authState.permissions.includes('show-invoice')) && (
                            { path: `${process.env.PUBLIC_URL}/billing/invoice`, title: 'Invoice', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('show-invoice-cancel')) && (
                            { path: `${process.env.PUBLIC_URL}/billing/invoice-cancel`, title: 'Cancelled Invoice', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('show-collection-received')) &&
                        { path: `${process.env.PUBLIC_URL}/billing/payment-collection`, title: 'Collection Recieved', type: 'link' }
                    ]
                }),
                (authState.userRole === 1 ||
                    authState.permissions.includes('show-package') ||
                    authState.permissions.includes('show-add-on') ||
                    authState.permissions.includes('show-stock') ||
                    authState.permissions.includes('show-item')) &&
                ({
                    title: 'Products', icon: Package, type: 'sub', active: false, children: [
                        // (authState.userRole === 1 || authState.permissions.includes('show-package')) && (
                        //     { path: `${process.env.PUBLIC_URL}/Services/packages`, title: 'Packages', type: 'link' }
                        // ),
                        // (authState.userRole === 1 || authState.permissions.includes('show-add-on')) && (
                        //     { path: `${process.env.PUBLIC_URL}/Services/addon`, title: 'Addons', type: 'link' }
                        // ),
                        (authState.userRole === 1 || authState.permissions.includes('show-item')) && (
                            { path: `${process.env.PUBLIC_URL}/Product/item`, title: 'Items', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('show-warranty')) && (
                            { path: `${process.env.PUBLIC_URL}/Product/warranty`, title: 'Warranty', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('show-stock')) && (
                            { path: `${process.env.PUBLIC_URL}/Product/stock-list`, title: 'Users Stocks', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('show-stock')) && (
                            { path: `${process.env.PUBLIC_URL}/Product/stock-history`, title: 'Stock History', type: 'link' }
                        ),
                        // (authState.userRole === 1 || authState.permissions.includes('show-stock_history')) && (
                        //     { path: `${process.env.PUBLIC_URL}/Services/stock-history`, title: 'stock-history', type: 'link' }
                        // ),

                    ]
                }),
                //  (authState.userRole === 1 ||                
                //     authState.permissions.includes('show-services')) &&
                ({
                    title: 'Service Plan', icon: Server, type: 'sub', active: false, children: [
                        // (authState.userRole === 1 || authState.permissions.includes('show-Services')) && 
                        (
                            { path: `${process.env.PUBLIC_URL}/Services/services-list`, title: 'Service Plan', type: 'link' }
                        ),
                    ]
                }),
                (authState.userRole === 1 ||
                    authState.permissions.includes('show-expense') ||
                    authState.permissions.includes('show-income') ||
                    authState.permissions.includes('show-header') ||
                    authState.permissions.includes('show-vendor')) &&
                ({
                    title: 'Expenses & Income', icon: TrendingUp, type: 'sub', active: false, children: [
                        (authState.userRole === 1 || authState.permissions.includes('show-expense')) && (
                            { path: `${process.env.PUBLIC_URL}/Expenses/Expenses`, title: 'Expense', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('show-income')) && (
                            { path: `${process.env.PUBLIC_URL}/Expenses/Income`, title: 'income', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('show-header')) && (
                            { path: `${process.env.PUBLIC_URL}/Expenses/Header`, title: 'Header', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('show-vendor')) && (
                            { path: `${process.env.PUBLIC_URL}/Expenses/Vendor`, title: 'Vendor', type: 'link' }
                        ),
                    ]
                }),

                (authState.userRole === 1 ||
                    authState.permissions.includes('show-account') ||
                    authState.permissions.includes('show-transaction')) &&
                ({
                    title: 'Banking', icon: Archive, type: 'sub', active: false, children: [
                        (authState.userRole === 1 || authState.permissions.includes('show-account')) && (
                            { path: `${process.env.PUBLIC_URL}/banking/account`, title: 'Account', type: 'link' }
                        ),
                        (authState.userRole === 1 || authState.permissions.includes('show-transaction')) && (
                            { path: `${process.env.PUBLIC_URL}/banking/transaction`, title: 'Transaction', type: 'link' }
                        ),
                    ]
                }),
                (authState.userRole === 1 ||
                    authState.permissions.includes('show-report')) &&
                {
                    title: 'Reports', icon: Bookmark, type: 'sub', active: false, children: [
                        { path: `${process.env.PUBLIC_URL}/report/service-report`, title: 'Service Request ', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/report/service-dues`, title: 'Service Account Dues', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/report/service-not-done`, title: 'Missed Services', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/report/online-payment`, title: 'Online Payment', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/report/customer-payment`, title: 'Customer Payment', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/report/payment-collection`, title: 'Payment Collection', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/report/order-items-report`, title: 'Sales Order ', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/report/warranty-report`, title: 'Warranty Report', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/report/service-plan-report`, title: 'Service Plan Report', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/report/unpaid-customer`, title: 'Unpaid Customer', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/report/payment-due`, title: 'Payment Due', type: 'link' },
                        (Array.isArray(modules) && modules.some((item) => item?.module_name === 'stamping')) &&

                        // { path: `${process.env.PUBLIC_URL}/report/subscription-summary`, title: 'Subscription Summary', type: 'link' },
                        // { path: `${process.env.PUBLIC_URL}/report/package-summary`, title: 'Package Summary', type: 'link' },
                        // { path: `${process.env.PUBLIC_URL}/report/addon-summary`, title: 'Addon Summary', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/report/tax-report`, title: 'Tax Report', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/report/wallet-balance`, title: 'Wallet Balance', type: 'link' },

                        (authState.userRole === 1 || authState?.permissions?.includes('show-credit')) && (
                            { path: `${process.env.PUBLIC_URL}/report/sms-message-logs`, title: 'SMS Logs', type: 'link' }

                        ),
                        (authState.userRole === 1 || authState?.permissions?.includes('show-credit')) && (

                            { path: `${process.env.PUBLIC_URL}/report/whatsApp-message-logs`, title: 'WhatsApp Logs', type: 'link' }
                        ),
                        { path: `${process.env.PUBLIC_URL}/report/income-summary`, title: 'Income Summary', type: 'link' },
                        // { path: `${process.env.PUBLIC_URL}/report/income-vs-expence`, title: 'Income Vs Expense', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/report/expense-summary`, title: 'Expense Summary', type: 'link' },
                    ]
                },
                (Array.isArray(modules) && modules.some((item) => item?.module_name === 'KSEB Forms')) &&
                {
                    title: 'KSEB Forms', path: `${process.env.PUBLIC_URL}/settings/kseb-forms`, icon: FileMinus, type: 'link', active: false,
                },
                (authState.userRole === 1 ||
                    authState.permissions.includes('show-user')) &&
                {
                    title: 'Staff', icon: UserCheck, type: 'sub', active: false, children: [
                        { path: `${process.env.PUBLIC_URL}/menu/user`, title: 'Staff', type: 'link' },
                        (authState.userRole === 1) &&
                        { path: `${process.env.PUBLIC_URL}/menu/role`, title: 'Role', type: 'link' },
                    ]
                },

                (authState.userRole === 1 ||
                    authState.permissions.includes('show-area') ||
                    authState.permissions.includes('show-category')) &&
                (
                    {
                        title: 'Settings', icon: Settings, type: 'sub', active: false, children: [
                            (authState.userRole === 1 || authState.permissions.includes('show-area')) && (
                                { path: `${process.env.PUBLIC_URL}/settings/area`, title: 'Area', type: 'link' }
                            ),
                            (Array.isArray(modules) && modules.some((item) => item?.module_name === 'stamping')) &&

                            (authState.userRole === 1 || authState.permissions.includes('show-area')) && (
                                { path: `${process.env.PUBLIC_URL}/settings/taluk`, title: 'Taluk', type: 'link' }
                            ),

                            (Array.isArray(modules) && modules.some((item) => item?.module_name === 'stamping')) &&

                            (authState.userRole === 1 || authState.permissions.includes('show-area') || authState.permissions.includes('show-routes')) && (
                                { path: `${process.env.PUBLIC_URL}/settings/routes`, title: 'Routes', type: 'link' }
                            ),

                            (authState.userRole === 1 ||
                                authState.permissions.includes('show-lead-manager')) &&
                            { path: `${process.env.PUBLIC_URL}/settings/enquiry-status`, title: 'Enquiry/Lead Status', type: 'link' },
                            (authState.userRole === 1 || authState?.permissions?.includes('show-credit')) && (
                                { path: `${process.env.PUBLIC_URL}/settings/message-credit`, title: 'Message Credit', type: 'link' }
                            ),
                            authState.userRole === 1 &&
                            { path: `${process.env.PUBLIC_URL}/settings/brand`, title: 'Brand', type: 'link' },

                            authState.userRole === 1 && { path: `${process.env.PUBLIC_URL}/settings/service-duration`, title: 'Service Duration', type: 'link' },
                            authState.userRole === 1 &&
                            { path: `${process.env.PUBLIC_URL}/settings/problem-type`, title: 'Problem Type', type: 'link' },
                            // authState.userRole === 1 &&
                            // { path: `${process.env.PUBLIC_URL}/settings/casProvider`, title: 'Cas Provider', type: 'link' },
                            authState.userRole === 1 &&
                            { path: `${process.env.PUBLIC_URL}/settings/payment`, title: 'Payment Method', type: 'link' },
                            (authState.userRole === 1 || authState.permissions.includes('show-category')) && (
                                { path: `${process.env.PUBLIC_URL}/settings/categories`, title: 'Categories', type: 'link' }
                            ),
                            authState.userRole === 1 &&
                            { path: `${process.env.PUBLIC_URL}/settings/tax-group`, title: 'Tax Class', type: 'link' },
                            { path: `${process.env.PUBLIC_URL}/settings/qr-code`, new: openStatsus2, title: 'QR Code', type: 'link' },

                        ]
                    }),


                Array.isArray(modules) && modules.some((item) => item?.module_name === 'Attendance') &&
                (authState.userRole === 1 ||
                    authState.permissions.includes('show-attendace')) &&
                {
                    title: 'Attendance', icon: UserCheck, type: 'sub', active: false, children: [
                        { path: `${process.env.PUBLIC_URL}/attendance/dashboard`, title: 'Dashboard', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/attendance/employee-list`, title: 'Staff List', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/attendance/shifts`, title: 'Shifts', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/attendance/attendance-log`, title: 'Attendance Log', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/attendance/leave-management`, title: 'Leave Management', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/attendance/leave-type`, title: 'Leave Type', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/attendance/approvals`, title: 'Approvals', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/attendance/geofencing`, title: 'Geofencing', type: 'link' },
                        { path: `${process.env.PUBLIC_URL}/attendance/payroll-runs`, title: 'Payroll Runs', type: 'link' },
                    ]
                },
            ].filter(Boolean)
        },
    ]
}
